import { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/Text';

interface OpeningListProps {
  title: string;
  items: ReactNode[];
}

export default function OpeningList({ title, items }: OpeningListProps) {
  return (
    <div className="max-w-[470px]">
      <Text as="h2" variant="web/body/medium/md" className="mb-5">
        {title}
      </Text>
      <Text
        as="ul"
        variant="web/body/md"
        className="flex list-disc flex-col gap-8 pl-6"
      >
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </Text>
    </div>
  );
}
